'use strict';

var React = require('react'),
    ResponsiveImageQueueMixin = require('../mixins/ResponsiveImageQueueMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents');

require('./legacy/Stamp.less');
require('./BuyInItunes.less');

var COVER = {
  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/12/19/2014/be92ae37-d8d1-4d4b-afaf-0926d28a6e25.jpg',
  size: {
    width: 1024,
    height: 1024
  }
};

var BuyInItunes = React.createClass({
  mixins: [ResponsiveImageQueueMixin, PureRenderMixin],

  getImageOptions() {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: COVER,
      mode: 'scale_crop',
      sizes: {
        normal: true,
        retina: devicePixelRatio > 1.5
      }
    };
  },

  getImageSizes() {
    return {
      'default': 400,
      'xs': 560,
      'sm': 192,
      'md': 192,
      'lg': 192,
      'xl': 192
    };
  },

  render: function () {
    return (
      <div className='stamp-BuyInItunes'
           data-scroll-anchor>
        <div className='stamp-BuyInItunes-box'>
          <div className='stamp-BuyInItunes-label'>
            iTunes Store
          </div>
          {this.renderLoaderImg()}

          <div className='stamp-BuyInItunes-cover' style={{backgroundImage: this.getBackgroundImageUrl()}}>
            <a className='stamp-BuyInItunes-coverLink'
               href='https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4'
               target='_blank'
               onClick={this.handleClick} />
          </div>

          <div className='stamp-BuyInItunes-meta'>
            {/**
              * Note: use <a> instead of <Link> and <Button>
              * because our elements don't trigger onClick
              * with target="_blank" and we don't want to special
              * case them yet. If we later need this, we'll
              * revisit this part.
              */}
            <a className='stamp-BuyInItunes-title Link Link--underlineHover'
               href='https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4'
               target='_blank'
               onClick={this.handleClick}>
              Planetarium
            </a>
            <div className='stamp-BuyInItunes-artist'>
              Mujuice
            </div>
            <a className='Btn Btn--green Btn--medium Btn--fill stamp-BuyInItunes-button'
                    href='https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4'
                    target='_blank'
                    onClick={this.handleClick}>
              View in iTunes
            </a>
          </div>

        </div>
      </div>
    );
  },

  handleClick() {
    Analytics.trackEvent(AnalyticsEvents.STAMP_ACTION_BUY_IN_ITUNES);
  }
});

module.exports = BuyInItunes;



/** WEBPACK FOOTER **
 ** ./stamp/BuyInItunes.jsx
 **/